import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline'
import {skipToken} from '@reduxjs/toolkit/query'
import * as React from 'react'

import TransformText from '../../../../../containers/TransformText'
import {useBuildStatusTooltip} from '../../../../../hooks/useBuildStatusTooltip'
import {restApi} from '../../../../../services/rest'
import type {BuildTypeId, ChangeId, BuildId} from '../../../../../types'

import {getPersonalChangeArg} from './BuildStatusTooltip.rest'

import styles from './BuildStatusTooltip.css'

type Props = {
  changeId?: ChangeId | null | undefined
  buildId: BuildId
  buildTypeId?: BuildTypeId | null | undefined
}

function BuildStatusTooltip({buildId, buildTypeId, changeId}: Props) {
  const children = useBuildStatusTooltip(buildId)
  const {changeReady, changeComment} = restApi.endpoints.getChange.useQuery(
    changeId != null ? getPersonalChangeArg(changeId) : skipToken,
    {
      selectFromResult: ({data}) => ({
        changeReady: data != null,
        changeComment: data?.comment ?? 'No comment',
      }),
    },
  )

  return (
    <React.Fragment>
      {children}
      {changeId != null && (
        <React.Fragment>
          <br />
          {'Personal change: '}
          {changeReady ? (
            <TransformText
              text={changeComment}
              buildTypeId={buildTypeId}
              className={styles.comment}
            />
          ) : (
            <LoaderInline />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default BuildStatusTooltip
